import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=4d54a9ed"
import script from "./CallsList.vue?vue&type=script&lang=js"
export * from "./CallsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports